
import { BookingStatus } from "../../enums/booking-status";
import { PaidStatus } from "../../enums/paid-status";
import { RequestPermissionNotificationType } from "../../enums/request-permission-notification-type";
import { EditedTransaction } from "./edited-transaction";
import { RequestPermissionNotificationItem } from "./request-permission-notification-item";
import { RequestPermissionNotificationPayment } from "./request-permission-notification-payment";

export class RequestPermissionNotificationModel {
  constructor() {

  }

  public BookingOrTransactionClientId: number;
  public BookingOrTransactionTotalAmountBeforeDiscount: number;
  public BookingOrTransactionDiscountValueAll: number;
  public BookingOrTransactionTotalAmountAfterDiscount: number;
  public BookingOrTransactionTotalPrice: number;

  public RequestPermissionNotificationType: RequestPermissionNotificationType;
  public RefundReasonId: number;
  public RefundedItemsCount: number;
  public EditedTransaction: EditedTransaction;
  public RequestPermissionNotificationItems: RequestPermissionNotificationItem[];
  public RequestPermissionNotificationPayments: RequestPermissionNotificationPayment[];

  public BookingDateTime: Date;
  public BookingStatus: BookingStatus;
  public BookingPaidStatus: PaidStatus;
  public BookingId?: number;
  
}
